import React, { Component } from 'react';
import { isEmpty } from "lodash"
import { Box, CircularProgress, Paper, Typography, IconButton, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Currency from '../Currency';

// const useStyles = makeStyles((theme) => ({
const styles = theme => ({
    root: {
        position: "relative"
    },
    bottom: {
        color: "grey"
    },
    top: {
        animationDuration: "550ms",
        position: "absolute",
        left: 0
    },
    circle: {
        strokeLinecap: "round"
    }
});
  
export const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};
class ProgressCircle extends Component {
    state = {  }
    render() {
        const { classes } = this.props;
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');

        let valueTop = this.props.value || 0
        let colorBottom = "rgba(0,0,0,.04)"
        let colorTop = hex2rgba(this.props.color, .9)
        if ((this.props.value > this.props.max) && (this.props.max > 0)) {
            colorBottom = this.props.color 
            valueTop = this.props.value - 100
            colorTop =  "rgba(0,0,0,.45)"
        }
        return (
            <Box position="relative" display="inline-flex">
                <div className={classes.root}>
                    <CircularProgress
                        variant="determinate"
                        // className={classes.bottom}
                        style={{color: colorBottom}} 
                        value={100}
                        size={160} 
                        thickness={3} 
                    />
                    <CircularProgress
                        variant="determinate"
                        disableShrink
                        className={classes.top}
                        style={{color: colorTop }}
                        classes={{ circle: classes.circle }}
                        size={160} 
                        thickness={3} 
                        value={valueTop}
                    />
                    <Box
                        top={0}
                        left={0}
                        bottom={0}
                        right={0}
                        position="absolute"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Typography variant="caption" component="div" color="textSecondary">
                            <div><b><Currency value={Math.round(this.props.spent)} suffix={" "} /></b> / </div> 
                            <Currency value={Math.round(this.props.max)} suffix={" "} />
                        </Typography>
                    </Box> 
                </div>
            </Box>
        );
    }
}

export default withStyles(styles)(ProgressCircle);
